import "./Menu.css";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import LogoutIcon from "../../asset/logout-icon.png";
import AttendanceIcon from "../../asset/attendance-icon.png";
import PayrollIcon from "../../asset/payroll-icon.png";
import PayrolHistorylIcon from "../../asset/payroll-history.png";
import EditUserIcon from "../../asset/edit-user.png";
import AddUserIcon from "../../asset/adduser-icon.png";
import WhitelistIcon from "../../asset/whitelist-icon.png";
import PatrolIcon from "../../asset/patrol-icon.png";
import LiburTahunanIcon from "../../asset/liburtahunan-icon.png";
import NewsLetter from "../../asset/newsletter.png";
import FormLemburIcon from "../../asset/lembur-icon.png";
import TimLamaLogo from "../../asset/tim-lama.jpeg";
import ListRequest from "../../asset/listRequest.png";
import Apar from "../../asset/fire-icon.png";
import { postAxios } from "../../util/postAxios";
import { hasRole } from "../../util/function";

const Menu = () => {
  const getToken = localStorage.getItem("auth")
    ? localStorage.getItem("auth")
    : null;
  const getTim = localStorage.getItem("user");
  const jsonRole = JSON.parse(getTim);
  const canSeeRequest = hasRole(jsonRole, "super_user", "hrd_admin");

  const [notification, setNotification] = useState();

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getNotification`,
      { tim: jsonRole.tim },
      getToken,
      setNotification,
      ""
    );
  }, []);

  let history = useHistory();
  const location = useLocation();
  // menu aktif diambil dari URL, bukan state manual
  const menu = location.pathname.slice(1);

  const handleLogout = () => {
    localStorage.removeItem("auth");
    history.push("/login");
  };

  const goTo = (path) => history.push(`/${path}`);

  return (
    <>
      <div className="container-menu-mobile">
        <div
          style={{
            display: "flex",
            overflow: "auto",
            alignItems: "center",
            borderTop: "1px solid lightgray",
          }}
        >
          <img
            className={
              menu === "absensi" ? "img-menu-mobile-active" : "img-menu-mobile"
            }
            src={AttendanceIcon}
            onClick={() => goTo("absensi")}
          />
          {canSeeRequest ? (
            <img
              className={
                menu === "request"
                  ? "img-menu-mobile-active"
                  : "img-menu-mobile"
              }
              src={ListRequest}
              onClick={() => goTo("request")}
            />
          ) : (
            ""
          )}
          {!jsonRole.isNew ? (
            <img
              className={
                menu === "payroll"
                  ? "img-menu-mobile-active"
                  : "img-menu-mobile"
              }
              src={PayrollIcon}
              onClick={() => goTo("payroll")}
            />
          ) : (
            ""
          )}
          <img
            className={
              menu === "RekapAbsensi"
                ? "img-menu-mobile-active"
                : "img-menu-mobile"
            }
            src={PayrollIcon}
            onClick={() => goTo("RekapAbsensi")}
          />
          <img
            className={
              menu === "payrollHistory"
                ? "img-menu-mobile-active"
                : "img-menu-mobile"
            }
            src={PayrolHistorylIcon}
            onClick={() => goTo("payrollHistory")}
          />
          <img
            className={
              menu === "editUser" ? "img-menu-mobile-active" : "img-menu-mobile"
            }
            src={EditUserIcon}
            onClick={() => goTo("editUser")}
          />
          <img
            className={
              menu === "addUser" ? "img-menu-mobile-active" : "img-menu-mobile"
            }
            src={AddUserIcon}
            onClick={() => goTo("addUser")}
          />
          <img
            className={
              menu === "whiteList"
                ? "img-menu-mobile-active"
                : "img-menu-mobile"
            }
            src={WhitelistIcon}
            onClick={() => goTo("whiteList")}
          />
          <img
            className={
              menu === "patrolSecurity"
                ? "img-menu-mobile-active"
                : "img-menu-mobile"
            }
            src={PatrolIcon}
            onClick={() => goTo("patrolSecurity")}
          />
          <img
            className={
              menu === "liburTahunan"
                ? "img-menu-mobile-active"
                : "img-menu-mobile"
            }
            src={LiburTahunanIcon}
            onClick={() => goTo("liburTahunan")}
          />
          <img
            className={
              menu === "formLembur"
                ? "img-menu-mobile-active"
                : "img-menu-mobile"
            }
            src={FormLemburIcon}
            onClick={() => goTo("formLembur")}
          />
          {jsonRole.tim === 1 ? (
            <>
              <img
                className={
                  menu === "newsLetter"
                    ? "img-menu-mobile-active"
                    : "img-menu-mobile"
                }
                src={NewsLetter}
                onClick={() => goTo("newsLetter")}
              />
              <img
                className={
                  menu === "APAR" ? "img-menu-mobile-active" : "img-menu-mobile"
                }
                src={Apar}
                onClick={() => goTo("APAR")}
              />
            </>
          ) : (
            ""
          )}
          <img
            style={{
              width: "24px",
              height: "24px",
              margin: "10px 12px 18px 36px",
            }}
            src={LogoutIcon}
            onClick={() => handleLogout()}
          />
        </div>
      </div>
      <div className="container-menu">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "12px 0",
          }}
        >
          <img src={TimLamaLogo} style={{ width: "56px", height: "56px" }} />
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <label
            className={menu === "absensi" ? "menu-marker" : "display-none"}
          >
            a
          </label>
          <div
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            onClick={() => goTo("absensi")}
          >
            <img
              className={menu === "absensi" ? "img-menu-active" : "img-menu"}
              src={AttendanceIcon}
            />
            <div className={menu === "absensi" ? "menu_active" : "menu"}>
              Absensi
            </div>
          </div>
        </div>
        {canSeeRequest ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            <label
              className={menu === "request" ? "menu-marker" : "display-none"}
            >
              a
            </label>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => goTo("request")}
            >
              <img
                className={menu === "request" ? "img-menu-active" : "img-menu"}
                src={ListRequest}
              />
              <div className={menu === "request" ? "menu_active" : "menu"}>
                Request
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {!jsonRole.isNew ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            <label
              className={menu === "payroll" ? "menu-marker" : "display-none"}
            >
              a
            </label>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => goTo("payroll")}
            >
              <img
                className={menu === "payroll" ? "img-menu-active" : "img-menu"}
                src={PayrollIcon}
              />
              <div className={menu === "payroll" ? "menu_active" : "menu"}>
                Payroll
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        <div
          style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          onClick={() => goTo("RekapAbsensi")}
        >
          <img
            className={menu === "RekapAbsensi" ? "img-menu-active" : "img-menu"}
            src={PayrollIcon}
          />
          <div className={menu === "RekapAbsensi" ? "menu_active" : "menu"}>
            RekapAbsensi
          </div>
        </div>

        <div
          style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          onClick={() => goTo("payrollHistory")}
        >
          <img
            className={
              menu === "payrollHistory" ? "img-menu-active" : "img-menu"
            }
            src={PayrolHistorylIcon}
          />
          <div className={menu === "payrollHistory" ? "menu_active" : "menu"}>
            Payroll History
          </div>
        </div>

        <div style={{ display: "flex", alignItems: "center" }}>
          <label
            className={menu === "editUser" ? "menu-marker" : "display-none"}
          >
            a
          </label>
          <div
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            onClick={() => goTo("editUser")}
          >
            <img
              className={menu === "editUser" ? "img-menu-active" : "img-menu"}
              src={EditUserIcon}
            />
            <div className={menu === "editUser" ? "menu_active" : "menu"}>
              Edit User
            </div>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <label
            className={menu === "addUser" ? "menu-marker" : "display-none"}
          >
            a
          </label>
          <div
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            onClick={() => goTo("addUser")}
          >
            <img
              className={menu === "addUser" ? "img-menu-active" : "img-menu"}
              src={AddUserIcon}
            />
            <div className={menu === "addUser" ? "menu_active" : "menu"}>
              Add User
            </div>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <label
            className={menu === "whiteList" ? "menu-marker" : "display-none"}
          >
            a
          </label>
          <div
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            onClick={() => goTo("whiteList")}
          >
            <img
              className={menu === "whiteList" ? "img-menu-active" : "img-menu"}
              src={WhitelistIcon}
            />
            <div className={menu === "whiteList" ? "menu_active" : "menu"}>
              Whitelist
            </div>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <label
            className={
              menu === "patrolSecurity" ? "menu-marker" : "display-none"
            }
          >
            a
          </label>
          <div
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            onClick={() => goTo("patrolSecurity")}
          >
            <img
              className={
                menu === "patrolSecurity" ? "img-menu-active" : "img-menu"
              }
              src={PatrolIcon}
            />
            <div className={menu === "patrolSecurity" ? "menu_active" : "menu"}>
              Patrol
            </div>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <label
            className={menu === "liburTahunan" ? "menu-marker" : "display-none"}
          >
            a
          </label>
          <div
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            onClick={() => goTo("liburTahunan")}
          >
            <img
              className={
                menu === "liburTahunan" ? "img-menu-active" : "img-menu"
              }
              src={LiburTahunanIcon}
            />
            <div className={menu === "liburTahunan" ? "menu_active" : "menu"}>
              Libur Tahunan
            </div>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <label
            className={menu === "formLembur" ? "menu-marker" : "display-none"}
          >
            a
          </label>
          <div
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            onClick={() => goTo("formLembur")}
          >
            <img
              className={menu === "formLembur" ? "img-menu-active" : "img-menu"}
              src={FormLemburIcon}
            />
            <div className={menu === "formLembur" ? "menu_active" : "menu"}>
              Form Lembur
            </div>
          </div>
        </div>
        {jsonRole.tim === 1 ? (
          <>
            <div style={{ display: "flex", alignItems: "center" }}>
              <label
                className={
                  menu === "newsLetter" ? "menu-marker" : "display-none"
                }
              >
                a
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => goTo("newsLetter")}
              >
                <img
                  className={
                    menu === "newsLetter" ? "img-menu-active" : "img-menu"
                  }
                  src={NewsLetter}
                />
                <div className={menu === "newsLetter" ? "menu_active" : "menu"}>
                  News Letter
                </div>
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <label
                className={menu === "APAR" ? "menu-marker" : "display-none"}
              >
                a
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => goTo("APAR")}
              >
                <img
                  className={menu === "APAR" ? "img-menu-active" : "img-menu"}
                  src={Apar}
                />
                <div className={menu === "APAR" ? "menu_active" : "menu"}>
                  APAR
                </div>
                {notification && notification.apar > 0 ? (
                  <div className="notification-menu">
                    {notification && notification.apar}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </>
        ) : (
          ""
        )}
        <br />
        <br />
        <p style={{ fontSize: "14px", margin: "12px 0 12px 24px" }}>
          Hello {jsonRole.name.split(" ").slice(0, 1).join(" ")}, TIM{" "}
          {jsonRole.tim}
        </p>
        <br />
        <div
          onClick={() => handleLogout()}
          style={{
            display: "flex",
            alignItems: "center",
            marginLeft: "24px",
            cursor: "pointer",
          }}
        >
          <img
            style={{
              width: "24px",
              height: "24px",
              filter: "grayscale(1) invert(1)",
            }}
            src={LogoutIcon}
          />
          <p style={{ margin: "0 0 0 6px", color: "white", fontWeight: "550" }}>
            Sign out
          </p>
        </div>
      </div>
    </>
  );
};
export default Menu;
